import { createContext } from "react";

export interface IBudgetDetailContext {
    budgetRemaining: number;
    budgetSpent: number,
    totalRequest: number,
    yearlyBudget: number,
    setBudgetRemaining: (num: number) => void,
    setBudgetSpent: (num: number) => void,
    setTotalRequest: (num: number) => void,
    setYearlyBudget: (num: number) => void,
    fetchBudgetDetails: () => void
}

export const BudgetDetailContext = createContext<IBudgetDetailContext | undefined>(undefined);